import styled from 'styled-components';

import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { spacing } from 'ui/theme';
import { useEditableFieldsContext } from '../context/EditableFieldsContext';
import { useQueryParamContext } from '../context/QueryParamContext';
import { useTemplateQueryContext } from '../context/TemplateQueryContext';
import { displayContent } from './content';
import { LastSavedIndicator, DetailsButton } from './Controls';
import { TemplateEditViews } from './types';
import { useSaveTemplate } from '../hooks/useSaveTemplate';

// footer for Preview with Data

const ControlContainer = styled.div`
  align-items: center;
  display: flex;
  column-gap: ${spacing.half};
  flex: 0 0 auto;
`;

const LeftContainer = styled.div`
  align-items: center;
  display: flex;
  column-gap: ${spacing.half};
  flex: 1 1 auto;
`;

export const ViewFooter = () => {
  const { setView } = useQueryParamContext();
  const { saveTemplate } = useSaveTemplate();
  const { isDirty, skipUnsavedChangesCheck } = useEditableFieldsContext();
  const { refetch } = useTemplateQueryContext();

  return (
    <>
      <LeftContainer>
        <DetailsButton />
      </LeftContainer>
      <ControlContainer>
        <LastSavedIndicator />
        {isDirty ? (
          <Button
            data-test={'template-editor-details-button'}
            onClick={() =>
              saveTemplate(() => {
                refetch();
                skipUnsavedChangesCheck.current = true;
                setView(TemplateEditViews.settings);
              })
            }
            size={BUTTON_SIZES.LARGE}
            variant={BUTTON_VARIANTS.PRIMARY}
          >
            <span>{displayContent.btnSaveDetailsAndExit}</span>
          </Button>
        ) : (
          <Button
            data-test={'template-editor-details-button'}
            onClick={() => setView(TemplateEditViews.settings)}
            size={BUTTON_SIZES.LARGE}
            variant={BUTTON_VARIANTS.PRIMARY}
          >
            <span>{displayContent.btnExitPreview}</span>
          </Button>
        )}
      </ControlContainer>
    </>
  );
};
